export { MovieRating } from './MovieRating'
